import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service//webapp/android apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const AndroidApps = () => {
  const heroData = {
    title: "Professional Android App Development",
    description: "Build powerful native Android apps that engage users and drive business growth. We create high-performance mobile experiences optimized for the Android ecosystem.",
    image: img13,
    imageAlt: "Android Apps",
    features: [
      "Native Kotlin/Java development",
      "Material Design interfaces",
      "Multi-device optimization",
      "Cloud integration",
      "Offline functionality",
      "Play Store publishing",
    ],
    pillars: [
      "Native performance that delivers smooth, responsive experiences",
      "Intuitive design that follows Android conventions and user expectations",
      "Robust architecture that scales and maintains quality over time",
    ],
  };

  const journeySteps = [
    {
      title: "Discovery & Strategy",
      description: "We analyze your business goals, target users, and market to create a strategic Android app roadmap aligned with your objectives.",
      details: ["Business goals", "User personas", "Competitor benchmarking", "Feature roadmap", "Tech stack decision", "Project scope & timeline"],
    },
    {
      title: "Design & Experience",
      description: "Our designers create stunning Material Design interfaces that provide intuitive, engaging user experiences following Android best practices.",
      details: ["Mood boards", "Wireframes", "High-fidelity UI", "Material Design", "Interactive prototypes", "Accessibility (WCAG)"],
    },
    {
      title: "Development & Performance",
      description: "We build high-performance Android apps using Kotlin and Java, leveraging native APIs and platform-specific features for optimal results.",
      details: ["Clean code architecture", "Kotlin/Java", "Backend/API", "Database & auth", "Performance optimization", "Security hardening"],
    },
    {
      title: "Launch & Momentum",
      description: "Comprehensive testing across devices and Android versions ensures smooth Play Store launch and ongoing support.",
      details: ["Multi-stage testing", "Device compatibility", "Analytics & tracking", "Play Store publishing", "Post-launch monitoring", "Ongoing support"],
    },
  ];

  const capabilities = [
    {
      title: "Native Android Apps",
      content: "High-performance native apps built with Kotlin/Java that leverage Android's full capabilities for exceptional user experiences.",
    },
    {
      title: "Material Design UI",
      content: "Beautiful, intuitive interfaces following Google's Material Design principles for consistent, modern user experiences.",
    },
    {
      title: "API Integration",
      content: "Seamless integration with backend services, third-party APIs, and cloud platforms for connected app experiences.",
    },
    {
      title: "App Optimization",
      content: "Performance optimization, battery efficiency, and data usage optimization for smooth operation across all Android devices.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "4.6+", label: "Average Play Store rating" },
      { value: "85%", label: "User retention (30 days)" },
      { value: "<1%", label: "Crash rate on devices" },
    ],
    description: "We deliver Android apps that achieve high user engagement, strong ratings, and measurable business impact through exceptional design and performance.",
  };

  const outcomesData = {
    description: "We create Android apps that combine beautiful Material Design with robust functionality, delivering exceptional mobile experiences that users love.",
    outcomes: [
      "Native Kotlin/Java development for peak performance",
      "Material Design 3 implementation",
      "Multi-device and screen size support",
      "Offline functionality and data sync",
      "Push notifications and real-time updates",
      "Play Store optimization and ASO",
    ],
  };

  const whyChooseUs = [
    {
      title: "Android Experts",
      content: "Our team has deep expertise in Android development, staying current with the latest Android versions and best practices.",
    },
    {
      title: "User-Centric Design",
      content: "We prioritize user experience, creating intuitive interfaces that delight users and drive engagement.",
    },
    {
      title: "Quality Assurance",
      content: "Rigorous testing across devices, screen sizes, and Android versions ensures flawless performance for all users.",
    },
    {
      title: "Ongoing Support",
      content: "From launch to updates, we provide continuous support, maintenance, and feature enhancements for your app.",
    },
  ];

  const faqs = [
    {
      q: "What technologies do you use for Android app development?",
      a: "We primarily use Kotlin as the modern language for Android development, along with Java for legacy support. Our tech stack includes Jetpack Compose for UI, Room for databases, Retrofit for networking, and Firebase for backend services.",
    },
    {
      q: "How long does it take to develop an Android app?",
      a: "Development timelines vary based on complexity. A basic Android app takes 8-12 weeks, while complex apps with advanced features require 16-24 weeks. We provide detailed timelines during the discovery phase.",
    },
    {
      q: "Will my Android app work on all devices?",
      a: "Yes, we ensure compatibility across a wide range of Android devices and versions. Our testing process covers various screen sizes, resolutions, and Android OS versions to guarantee consistent performance.",
    },
    {
      q: "Do you handle Google Play Store submission?",
      a: "Absolutely. We manage the complete Play Store submission process, including app optimization, compliance with Google's policies, ASO (App Store Optimization), and ongoing management of updates and releases.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Android App Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Android App Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AndroidApps;
